/**
 * PrivacyPolicyPage
 *
 * Public Privacy Policy at /privacy. Required by Google OAuth verification,
 * Stripe, App stores, GDPR (EU/UK/EEA) and LGPD (Brazil) — all of which
 * mandate a publicly accessible URL distinct from the Terms of Service.
 */

import { ArrowLeft, ShieldCheck } from 'lucide-react';
import { PrivacyContent } from '../../components/legal';
import { useTranslation } from '../../hooks/useTranslation';

interface PrivacyPolicyPageProps {
  onNavigateHome: () => void;
}

export function PrivacyPolicyPage({ onNavigateHome }: PrivacyPolicyPageProps) {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#0a0015] text-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <button
          onClick={onNavigateHome}
          className="inline-flex items-center gap-2 text-white/60 hover:text-white mb-6 transition-colors min-h-[44px]"
        >
          <ArrowLeft className="h-4 w-4" />
          <span>{t('privacy.backToApp')}</span>
        </button>

        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-700 rounded-2xl mb-5 shadow-lg shadow-purple-500/25">
            <ShieldCheck className="h-8 w-8 text-white" />
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold mb-3">{t('privacy.title')}</h1>
          <p className="text-white/60">{t('privacy.subtitle')}</p>
          <p className="mt-3 text-xs text-white/40">
            {t('privacy.version')} 1.0 · {t('privacy.lastUpdated')}: 2026-05-26
          </p>
        </div>

        <div className="space-y-6 bg-black/30 backdrop-blur-xl border border-white/10 rounded-2xl p-6 sm:p-8">
          <PrivacyContent />
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
